class Slider {
    constructor(c) {
        this.parent = c.parent
        this.arrowPrev = this.parent.querySelector('[data-slider-arrow-prev]') ? this.parent.querySelector('[data-slider-arrow-prev]') : undefined
        this.arrowNext = this.parent.querySelector('[data-slider-arrow-next]') ? this.parent.querySelector('[data-slider-arrow-next]') : undefined
        this.layout = this.parent.querySelector('.wu-carousel__layout')
        this.list = this.parent.querySelector('.wu-carousel__layout__list')
        this.slide = this.parent.querySelectorAll('.wu-carousel__layout__list__item')
        this.length = parseInt(this.slide.length)
        this.cols = parseInt(this.list.dataset.showCols)
        this.scrollWidth = this.slide.length > 0 ? this.slide[0].offsetWidth : 0
        this.clicksAllowed = this.length - this.cols
        this.scrollTo = 0
        this.scrollCount = 0

        this.offsets = this.list.getAttribute('data-mobile-big-offsets') != null ? true : false




        this.init()
    }
    init() {
        if (this.arrowPrev && (document.dir == "" || document.dir == null)) {
            this.arrowPrev.classList.add('wu-icon--disabled');
        }
        if (this.arrowNext && document.dir == "rtl") {
            this.arrowNext.classList.add('wu-icon--disabled');
        }
        this.listeners()
        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
            var evt = document.createEvent('UIEvents');
            evt.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(evt);
        } else {
              window.dispatchEvent(new CustomEvent('resize'));
        }
        // window.dispatchEvent(new CustomEvent('resize'))
        this.handlerWindowResize()
    }
    listeners() {
        if (this.arrowPrev) {
            this.arrowPrev.addEventListener('click', e => {
                this.scrollWidth = this.slide[0].offsetWidth
                this.handlerClickArrowPrev()
            }, true)
        }
        if (this.arrowNext) {
            this.arrowNext.addEventListener('click', e => {
                this.scrollWidth = this.slide[0].offsetWidth
                this.handlerClickArrowNext()
            }, false)
        }
        if (this.arrowNext && this.arrowPrev) {
            this.layout.addEventListener('scroll', e => {
                this.scrollWidth = this.slide[0].offsetWidth
                //this.handlerLayoutScroll()
            })
        }
        window.addEventListener('resize', e => {
            this.scrollWidth = this.slide.length > 0 ? this.slide[0].offsetWidth : 0
            this.handlerWindowResize()
        })
    }
    handlerClickArrowPrev() {
        this.arrowNext.classList.remove('wu-icon--disabled');
        if (this.scrollCount * -1 < this.clicksAllowed){
            this.scrollCount--;
        }
        (this.scrollCount * -1 === this.clicksAllowed || this.scrollCount == 0) && this.arrowPrev.classList.add('wu-icon--disabled');
        this.slideTo(this.scrollCalc('prev') * -1);
    }
    handlerClickArrowNext() {
        this.arrowPrev.classList.remove('wu-icon--disabled');
        if (this.scrollCount < this.clicksAllowed){
            this.scrollCount++;
        }
        if(this.scrollCount === this.clicksAllowed || this.scrollCount == 0) {
            this.arrowNext.className += ' wu-icon--disabled';
            this.arrowNext.classList.add('wu-icon--disabled');
        }
        this.slideTo(this.scrollCalc('next'));
        
    }
    handlerLayoutScroll() {
        var hasScrolledToLast = (parseInt(Math.round(this.layout.scrollWidth - this.layout.scrollLeft).toFixed(0)) === this.layout.offsetWidth);
        (this.layout.scrollLeft > 0) ? this.arrowPrev.classList.remove('wu-icon--disabled'): this.arrowPrev.classList.add('wu-icon--disabled');
        (hasScrolledToLast) ? this.arrowNext.classList.add('wu-icon--disabled'): this.arrowNext.classList.remove('wu-icon--disabled');
    }
    handlerWindowResize() {
        const _remove = () => {
            this.list.classList.remove(`wu-carousel__layout__list--4`)
            this.list.classList.remove(`wu-carousel__layout__list--3`)
            this.list.classList.remove(`wu-carousel__layout__list--2_5`)
            this.list.classList.remove(`wu-carousel__layout__list--2`)
            this.list.classList.remove(`wu-carousel__layout__list--1_5`)
        }
        const _add = cols => {
            if(!cols) throw new Error('cols not defined')
            if(typeof cols !== 'string') throw new Error('cols must be string')
            const _correctCols = cols.toString().replace('.', '_')
            this.list.classList.add(`wu-carousel__layout__list--${_correctCols}`)
        }

        let windowWidth = document.documentElement.clientWidth;
        if(!!this.list.getAttribute('data-show-cols')) {
            if(windowWidth > 1024){
                _remove()
                _add(this.list.getAttribute('data-show-cols'))
            }
        }
        if(!!this.list.getAttribute('data-show-cols-md')) {
            if(windowWidth <= 1024 && windowWidth > 780){
                _remove()
                _add(this.list.getAttribute('data-show-cols-md'))
            }
        }
        if(!!this.list.getAttribute('data-show-cols-sm')) {
            if(windowWidth <= 780 && windowWidth > 500){
                _remove()
                _add(this.list.getAttribute('data-show-cols-sm'))
            }
        }
        if(!!this.list.getAttribute('data-show-cols-xs')) {
            if(windowWidth <= 500){
                _remove()
                _add(this.list.getAttribute('data-show-cols-xs'))
            }
        }

        // if (window.innerWidth < 1024 && window.innerWidth >= 781 && !!this.list.getAttribute('data-show-cols-tablet')) {
        //     let _cols = +(this.list.getAttribute('data-show-cols-tablet'))
        //     this.list.classList.remove(`wu-carousel__layout__list--${this.cols.toString().replace('.', '-')}`)
        //     this.list.classList.add(`wu-carousel__layout__list--${_cols.toString().replace('.', '-')}`)
        //     if (this.offsets) {
        //         this.list.classList.add('wu-carousel__layout__list--big-offsets')
        //     }
        //
        //     this.cols = _cols
        // }
        // else if (window.innerWidth < 780) {
        //     this.list.classList.remove(`wu-carousel__layout__list--${this.cols.toString().replace('.', '-')}`)
        //     this.list.classList.add('wu-carousel__layout__list--1_5')
        //     if (this.offsets) {
        //         this.list.classList.add('wu-carousel__layout__list--big-offsets')
        //     }
        //
        //     this.cols = 1
        // } else {
        //     this.list.classList.remove('wu-carousel__layout__list--1_5')
        //     this.list.classList.add(`wu-carousel__layout__list--${this.cols.toString().replace('.', '-')}`)
        //
        //     this.list.classList.remove('wu-carousel__layout__list--big-offsets')
        //
        //     this.cols = parseInt(this.list.dataset.showCols)
        // }
        // this.clicksAllowed = this.length - this.cols
            // }
    }
    slideTo(param) {
        this.layout.scrollBy({
            top: 0,
            left: param,
            behavior: 'smooth'
        });
    }
    scrollCalc(dirc) {
        let scrollLeft = this.layout.scrollLeft;
        let result = 0;
        if (dirc === 'next') return this.scrollWidth;
        if (Math.ceil(scrollLeft) % this.scrollWidth != 0) {
            let multipler = Math.ceil(scrollLeft / this.scrollWidth);
            if (dirc !== 'next') {
                result = Math.ceil(scrollLeft) - this.scrollWidth * (multipler - 1);
            }
        } else {
            result = this.scrollWidth;
        }
        return result;
    }
}

let tot_slider = document.querySelectorAll('.wu-carousel')
if (tot_slider.length > 0) {
    for (let i = 0; i < tot_slider.length; i++) {
        new Slider({
            parent: tot_slider[i]
        })
    }
}

var slideIndex = 0;
wuSlides(slideIndex);
autoSlides();
function autoSlides() {
    var a;
    var aSlides = document.getElementsByClassName("wu-mySlider");
    var adots = document.getElementsByClassName("dot-carousel");
    if(aSlides != undefined && aSlides !== null && aSlides != ""){
        for (a = 0; a < aSlides.length; a++) {
            aSlides[a].style.display = "none";
        }
        slideIndex++;
        if (slideIndex > aSlides.length) { slideIndex = 1 }
        for (a = 0; a < adots.length; a++) {
            adots[a].className = adots[a].className.replace(" active-carousel", "");
        }
        
        
        if(aSlides[slideIndex - 1] !== undefined){
            aSlides[slideIndex - 1].style.display = "block";
            
            let image = aSlides[slideIndex - 1].querySelector('img');
            if (!image.getAttribute('src')) {
                image.setAttribute('src', image.getAttribute('data-lazyload-mobile-desktop-src'))
            }
        }
        if(adots[slideIndex - 1] !== undefined){
            adots[slideIndex - 1].className += " active-carousel";
        }
        setTimeout(autoSlides, 10000);
    }
    
}

function currentSlide(n) {
    wuSlides(slideIndex = n);
}

function wuSlides(n) {
    var i;
    var slides = document.getElementsByClassName("wu-mySlider");
    var dots = document.getElementsByClassName("dot-carousel");
    if(slides != undefined && slides !== null && slides != ""){
        if (n > slides.length) { slideIndex = 1 }
        if (n < 1) { slideIndex = slides.length }
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active-carousel", "");
        }
        if(slides[slideIndex - 1] !== undefined){
            slides[slideIndex - 1].style.display = "block";
        }
        if(dots[slideIndex - 1] !== undefined){
            dots[slideIndex - 1].className += " active-carousel";
        }
        
    }
    //setTimeout(wuSlides(n), 2000);
}

